import React from "react";
import { Globe } from "@phosphor-icons/react";

const FUNNEL_BY_EXPERIENCE = { standard: "standard", quiz: "quiz", focused_funnel: "focused" };

const isSample = (f) => Boolean(f.is_sample_page) || (f.slug || "").startsWith("sample-");

export const GlobalFunnelNotice = ({ form }) => {
  // Buyer landers are their own live page (custom-lp-lander-notice explains them).
  if (!form?.slug || isSample(form) || form.buyer_lander_of) return null;
  if (form.is_global_funnel) {
    return (
      <div className="border-2 border-emerald-800 bg-emerald-50 p-3 mb-4 text-xs text-emerald-950 flex gap-2"
           data-testid="global-funnel-notice-template">
        <Globe size={14} weight="bold" className="mt-0.5 flex-shrink-0" />
        <div>
          <b>Shared funnel · /lp/{form.slug}.</b> The headline, hero, stats, sections and form settings
          here are shown to every buyer. Each buyer&apos;s company details (name, phone, brand color,
          consent text, privacy/terms, thank-you) load from their own page via <span className="font-mono">?b=</span>.
        </div>
      </div>
    );
  }
  const v2 = form.form_experience === "quiz" && (form.quiz_config || {}).layout === "v2";
  const funnel = v2 ? "quiz-v2" : FUNNEL_BY_EXPERIENCE[form.form_experience || "standard"] || "standard";
  return (
    <div className="border-2 border-sky-800 bg-sky-50 p-3 mb-4 text-xs text-sky-950 flex gap-2"
         data-testid="global-funnel-notice-buyer">
      <Globe size={14} weight="bold" className="mt-0.5 flex-shrink-0" />
      <div>
        <b>Live traffic uses the shared funnel:</b>{" "}
        <span className="font-mono" data-testid="global-funnel-notice-url">/lp/{funnel}?b={form.slug}</span>.
        Only this page&apos;s company details are used there — firm name, phone, brand color, consent text,
        privacy/terms, thank-you copy, accepted states, buyer destination and buyer pixels.
        Headline, hero and stats come from the shared funnel. Old links to /lp/{form.slug} forward automatically.
      </div>
    </div>
  );
};
